import { useContext } from 'react';
import AccordianContext from '../contexts/AccordianContext';
const useAccordionContext = () => {
  const context = useContext(AccordianContext);
  if (!context) {
    throw new Error(
      'Accordion components are compound component. Must be used inside Accordion.'
    );
  }
  return context;
};

export { useAccordionContext };
